
export default {
  name: "SearchBar",
  props: {
    placholder_text: String,
  },
};
